export const DEPARTMENTS = [
  { name: "Engineering", head: "Arjun Kumar",      employees: 342, budget: "$4.2M", growth: "+8%"  },
  { name: "Product",     head: "Sarah Lee",         employees: 48,  budget: "$1.1M", growth: "+12%" },
  { name: "Design",      head: "Mira Patel",        employees: 36,  budget: "$820K", growth: "+5%"  },
  { name: "Analytics",   head: "Fatima Al-Hassan",  employees: 62,  budget: "$1.4M", growth: "+18%" },
  { name: "HR",          head: "Fatima Al-Hassan",  employees: 28,  budget: "$640K", growth: "+3%"  },
  { name: "Marketing",   head: "Sofia Martínez",    employees: 54,  budget: "$980K", growth: "+10%" },
  { name: "Finance",     head: "James Park",        employees: 32,  budget: "$720K", growth: "+2%"  },
];

export const TEAMS = [
  { name: "Frontend Guild",  dept: "Engineering", members: 24, lead: "Priya Sharma",      project: "HRMS Portal v3"       },
  { name: "Backend Squad",   dept: "Engineering", members: 18, lead: "Wei Chen",           project: "Microservices API"     },
  { name: "Design System",   dept: "Design",      members: 8,  lead: "Aiko Tanaka",        project: "Component Library"    },
  { name: "Growth Team",     dept: "Marketing",   members: 12, lead: "Sofia Martínez",     project: "Q2 Campaign"          },
  { name: "Data Platform",   dept: "Analytics",   members: 14, lead: "Carlos Rivera",      project: "Real-time Analytics"  },
  { name: "People Ops",      dept: "HR",          members: 6,  lead: "Fatima Al-Hassan",   project: "Onboarding Revamp"    },
];
